enum AssetMassAssignError {
  NOT_FOUND = 'not_found',
  ALREADY_REGISTERED = 'already_registered',
  DUPLICATE_INPUT = 'duplicate_input',
}

export default AssetMassAssignError
